import * as React from "react";
import styled from "styled-components";

import MobileToolbarToggle from "./MobileToolbarToggle";
import MobileToolbarItemsWrapper from "./MobileToolbarItemsWrapper";

const MobileToolbar: React.FC<any> = ({
  className,
  children,
  onMenuToggleClick
}) => (
  <div className={className}>
    <MobileToolbarToggle onClick={onMenuToggleClick} />
    <MobileToolbarItemsWrapper>{children}</MobileToolbarItemsWrapper>
  </div>
);

export default styled(MobileToolbar)`
  position: relative;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${p => p.theme.colors.grey200};
`;
